import { STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server'

import { normalizeMismatchForDisplay } from '@/assets/js/helper/smmarketingcomparison'

import http from '@/$plugins/http'

const DEFAULT_PAGE_SIZE = 100

export default {
  namespaced: true,
  state: {
    runs: [],
    mismatches: [],
    mismatchesPage: 1,
    mismatchesPageSize: DEFAULT_PAGE_SIZE,
    mismatchesTotalItems: 0,
    isLoading: false
  },
  mutations: {
    SET_RUNS (state, runs) {
      state.runs = runs
    },
    SET_MISMATCHES (state, mismatches) {
      state.mismatches = mismatches
    },
    SET_MISMATCHES_PAGING (state, { page, pageSize, totalItems }) {
      state.mismatchesPage = page
      state.mismatchesPageSize = pageSize
      state.mismatchesTotalItems = totalItems
    },
    SET_LOADING (state, isLoading) {
      state.isLoading = isLoading
    },
    RESET_MISMATCHES (state) {
      state.mismatches = []
      state.mismatchesPage = 1
      state.mismatchesPageSize = DEFAULT_PAGE_SIZE
      state.mismatchesTotalItems = 0
    }
  },
  actions: {
    loadRuns ({ commit }, options = {}) {
      const silent = !!options.silent
      if (!silent) {
        commit('SET_LOADING', true)
      }

      return http({
        method: 'get',
        url: `/${STOREMODULE_ENDPOINTMODULE_MAP.customer}/api/SmMarketingComparison/runs`
      })
        .then(response => {
          commit('SET_RUNS', response.data.result || [])
          return response.data.result || []
        })
        .finally(() => {
          if (!silent) {
            commit('SET_LOADING', false)
          }
        })
    },
    loadMismatches ({ commit, state }, { runId, page, pageSize } = {}) {
      const resolvedPage = page || state.mismatchesPage || 1
      const resolvedPageSize = pageSize || state.mismatchesPageSize || DEFAULT_PAGE_SIZE

      commit('SET_LOADING', true)
      return http({
        method: 'get',
        url: `/${STOREMODULE_ENDPOINTMODULE_MAP.customer}/api/SmMarketingComparison/runs/${runId}/mismatches`,
        params: {
          page: resolvedPage,
          pageSize: resolvedPageSize
        }
      })
        .then(response => {
          const data = response.data || {}
          const mismatches = (data.result || []).map(normalizeMismatchForDisplay)
          commit('SET_MISMATCHES', mismatches)
          commit('SET_MISMATCHES_PAGING', {
            page: data.pageNumber || resolvedPage,
            pageSize: data.pageSize || resolvedPageSize,
            totalItems: data.totalItems || 0
          })
          return mismatches
        })
        .finally(() => commit('SET_LOADING', false))
    },
    triggerComparison () {
      return http({
        method: 'post',
        url: `/${STOREMODULE_ENDPOINTMODULE_MAP.customer}/api/SmMarketingComparison/trigger`,
        // 409 = already running; handle in UI without the global API error toast
        validateStatus: status => (status >= 200 && status < 300) || status === 409
      }).then(response => {
        if (response.status === 409) {
          const error = new Error('alreadyRunning')
          error.response = response
          return Promise.reject(error)
        }
        return response
      })
    },
    downloadExcel (_, runId) {
      return http({
        method: 'get',
        url: `/${STOREMODULE_ENDPOINTMODULE_MAP.customer}/api/SmMarketingComparison/runs/${runId}/export`,
        responseType: 'blob'
      })
    }
  }
}
